import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/** Implemented by components that want to confirm before the user navigates away. */
export interface LeaveConfirmable {
  confirmLeave(): boolean | Observable<boolean>;
}

/**
 * Lets a component (e.g. the publication wizard) intercept navigation away and
 * prompt to save-as-draft / discard / stay.
 */
export const wizardLeaveGuard: CanDeactivateFn<LeaveConfirmable> = (component) =>
  component?.confirmLeave ? component.confirmLeave() : true;
